import { Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy, Injector, OnInit } from '@angular/core';
import { Component, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Utils } from 'formiojs';
import { Subscription } from 'rxjs';
import { ResourceNameService } from 'dp-formio';

declare var $: any;
@Component({
    selector: 'add-edit-dialog',
    templateUrl: 'add-edit-dialog.component.html',
    styleUrls: ['./add-edit-dialog.component.scss'],
})
export class AddEditDialog implements OnInit, OnChanges, OnDestroy {
    @Input() data: any;
    @Output() close = new EventEmitter<any>();

    submissionId: string;
    submission: any = {};
    formReady = false;
    disableFields: string = '';

    dialogRef: MatDialogRef<AddEditDialog>;
    dialogData: any;

    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    constructor(public fb: FormBuilder,
        private resourceNameService: ResourceNameService,
        private injector: Injector) {
        try {
            this.dialogRef = injector.get(MatDialogRef);
            this.dialogData = injector.get(MAT_DIALOG_DATA);
        } catch { }
    }
    ngOnInit() {
        if (!this.data) {
            this.data = this.dialogData;
            this.ngOnChanges(null);
        }
        
		$('.custom-modal-component mat-dialog-container').scroll(function () {
			$('.flatpickr-calendar').each((i,item) => {
				$(item).removeClass('open');
			});
		});
    }
    ngOnChanges(changes: SimpleChanges) {
        this.formReady = false;
        this.disableFields = '';
        this.submissionId = '';
        this.submission = {};

        setTimeout(() => {
            let extraOptions = {};
            if (this.data.extra)
                extraOptions = Utils.evaluate(this.data.extra, {
                    submission: this.data.data,
                    parentRowSubmission: this.data.parentRowSubmission,
                    rowSubmission: this.data.rowSubmission
                });

            if (this.data.disableFields) {
                const fields = [];
                this.data.disableFields.forEach(element => {
                    const defaultValue = Utils.evaluate(element.default, { branches: this.data.branches, rowSubmission: this.data.rowSubmission });
                    extraOptions[element.name] = defaultValue;
                    if (!this.data.isView && Utils.evaluate(element.disabled, { branches: this.data.branches }))
                        fields.push(element.name);
                });
                this.disableFields = fields.join();
            }


            if (this.data.rowSubmission)
                this.submissionId = this.data.rowSubmission._id;

            this.loadResource(extraOptions);
        });
    }

    loadResource(extraOptions: any) {
        if (this.submissionId) {
            this.sub = this.resourceNameService.loadCustomByKeyId(this.data.resource, this.submissionId)
                .subscribe(data => {
                    this.submission = data;
                    this.submission.data = { ...extraOptions, ...this.submission.data };
                    this.formReady = true;
                });
        } else {
            this.submission.data = { ...extraOptions };
            this.formReady = true;
        }
    }

    onFormLoad() {
        try {
            setTimeout(() => {
                const button = $('#columnsCancel');
                if (!button) {
                    this.onFormLoad();
                    return;
                }
                button.prop("disabled", false)
            }, 350)
        } catch (e) { }
    }

    onSubmit(submission) {
        this.data.rowSubmission = submission;
        this.data.fields.filter(q => q.viewInTree).forEach(element => {
            element.value = submission.data[element.name];
        });
        this.close.emit(this.data);
        if (this.dialogRef) this.dialogRef.close(this.data);
    }

    onCustomEvent(event) {
        if (event.type == 'customCancel') {
            this.close.emit();
            if (this.dialogRef) this.dialogRef.close();
        }
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

}
